export const NOT_PERFORMED = {
  id: 'not_performed',
  label: 'Non eseguita',
};

export const PERFORMED_POSITIVE = {
  id: 'performed_positive',
  label: 'Eseguita, esito positivo',
};

export const PERFORMED_NEGATIVE = {
  id: 'performed_negative',
  label: 'Eseguita, esito negativo',
};

export const PERFORMED_INCONCLUSIVE_FAILED = {
  id: 'performed_inconclusive_failed',
  label: 'Eseguita, esito non conclusivo/fallito',
};

export const UNKNOWN = {
  id: 'unknown',
  label: 'Non noto',
};
